import { Card, Grid } from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import * as Common from '@tfo/common'
import { Elements, enums } from '@tfo/common'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { useIntl } from 'react-intl'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useStore } from '../../hooks'
import logo from '../../media/images/tfo-logo.svg'
import './Header.scss'
const { Image, Label, Paragraph } = Elements

const Header = observer(() => {
	const intl = useIntl()
	const store = Common.hooks.useStore()
	const history = useHistory()
	const location = useLocation()
	const urlWindow = window.location;
	const acceptedPaths = ["password-policy-switch"];
	const rootStore = useStore()

	return (

		<header className="Header">
			{acceptedPaths.includes(urlWindow.pathname.split("/")[1]) || rootStore.clientViewStore.lockedMode ?
				<Image
					className="Header__LogoPasswordSwitch"
					src={logo}
				/>
				: <>
					<Link to="/start">
						<Image
							className="Header__Logo"
							src={logo}
							onClick={() =>
								history.push('/start')
							}
						/>
					</Link>
					{Common.utils.loggedIn() && (
						<>
							<div className='Header__Menu'>
								<Label>
									<Link
										to="/start"
										className={classnames('Header__MenuLabel', {
											'Header__MenuLabel--active':
												location.pathname === '/start',
										})}>
										{intl.formatMessage({ id: 'client.start.reports.heading' })}
									</Link>
								</Label>
								<Label>
									<Link
										to="/myaccount"
										className={classnames('Header__MenuLabel', {
											'Header__MenuLabel--active':
												location.pathname === '/myaccount',
										})}>
										{intl.formatMessage({ id: 'common.myAccount' })}
									</Link>
								</Label>
								{(store.userStore.user.roles !== null && store.userStore.user.roles !== undefined)
									&& store.userStore.user.roles[0].role == enums.CompanyUserRoles.SuperUser && (
										<Label>
											<Link
												to="/myorganisation"
												className={classnames('Header__MenuLabel', {
													'Header__MenuLabel--active':
														location.pathname === '/myorganisation',
												})}>
												{intl.formatMessage({ id: 'common.myOrganisation' })}
											</Link>
										</Label>
									)}

								{(store.userStore.user.roles !== null && store.userStore.user.roles !== undefined)
									&& store.userStore.user.roles[0].role == enums.CompanyUserRoles.SuperUser && (
										<Label>
											<Link
												to="/grouporder"
												className={classnames('Header__MenuLabel', {
													'Header__MenuLabel--active':
														location.pathname === '/grouporder',
												})}>
												{intl.formatMessage({ id: 'common.groupOrder' })}
											</Link>
										</Label>
									)}
							</div>
							<div className="Header__UserInfo">
								{store.clientViewStore.company && (
									<Label>{store.clientViewStore.company.name}</Label>
								)}
								{Common.utils.loggedIn() && (
									<div className="Header__Username">
										<Paragraph>{store.userStore.name}</Paragraph>

										<div className="HeaderListGroup">

											<button
												className="HeaderListButton"
												onClick={() => store.clientViewStore.onShowHeaderMenu()}
											><ExitToAppIcon /></button>

											{store.clientViewStore.showHeaderMenu && (
												<Card className="HeaderMenuBox">
													<Grid container direction="column" justifyContent="space-between">
														<Grid item>
															<p>
																<Link
																	to="/login"
																	className="HeaderMenuLabel"
																	onClickCapture={() => {
																		Common.utils.deleteCookie()
																		store.clientViewStore.onShowHeaderMenu()
																		window.location.href = '/login'
																	}}>
																	{intl.formatMessage({ id: `common.logout` })}
																</Link>
															</p>
														</Grid>
													</Grid>
												</Card>
											)}
										</div>
									</div>
								)}
							</div>
						</>
					)}
				</>
			}
		</header>
	)
})

export default Header
